import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "card shadow-sm mb-4 training-session-schedule" }
const _hoisted_2 = { class: "card-content py-2 px-4" }
const _hoisted_3 = {
  key: 0,
  class: "row"
}
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  key: 0,
  class: "alert alert-danger mt-3"
}
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = {
  key: 0,
  class: "alert alert-danger mt-3"
}
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 0,
  class: "alert alert-danger mt-3"
}
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = {
  key: 0,
  class: "alert alert-danger mt-3"
}
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "ts-users-select pt-2" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "checkbox-custom ts-user-select w-100 px-4 pt-2 cursor-pointer" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "ts-user-content overflow-hidden" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  key: 0,
  class: "alert alert-danger mt-3"
}
const _hoisted_27 = { class: "col-12 text-center" }
const _hoisted_28 = {
  key: 1,
  class: "loading-card-area"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_schedule_form = _resolveComponent("schedule-form")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[30] || (_cache[30] = _createElementVNode("div", { class: "card-header text-white bg-secondary fw-bold" }, "Schedule a Training Session", -1)),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.schedule_loading && !_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[10] || (_cache[10] = _createElementVNode("h4", null, "Select a Training Type", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.type) = $event)),
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.has_type_error = false))
              }, [
                _cache[9] || (_cache[9] = _createElementVNode("option", { value: "null" }, "--not set--", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.training_session_types, (ts_type) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: ts_type.id,
                    value: ts_type.id
                  }, _toDisplayString(ts_type.name) + " - " + _toDisplayString(ts_type.duration) + " hrs", 9, _hoisted_5))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.type]
              ]),
              (_ctx.has_type_error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.type_error), 1))
                : _createCommentVNode("", true),
              _cache[11] || (_cache[11] = _createElementVNode("hr", { class: "w-75 text-center" }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[12] || (_cache[12] = _createElementVNode("h4", null, "Select a Date & Time", -1)),
              _createVNode(_component_schedule_form, {
                is_single: true,
                field: "training_session_date",
                "alt-field": "none",
                "start-date": _ctx.start_date,
                onUpdateDate: _ctx.setDate
              }, null, 8, ["start-date", "onUpdateDate"]),
              (_ctx.has_date_error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.date_error), 1))
                : _createCommentVNode("", true),
              _cache[13] || (_cache[13] = _createElementVNode("hr", { class: "w-75 text-center" }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[15] || (_cache[15] = _createElementVNode("h4", null, "Select a Scenario", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.scenario) = $event)),
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.has_scenario_error = false))
              }, [
                _cache[14] || (_cache[14] = _createElementVNode("option", { value: "null" }, "--not set--", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.training_scenarios, (scenario) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: scenario.id,
                    value: scenario.id
                  }, _toDisplayString(scenario.patient_name), 9, _hoisted_10))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.scenario]
              ]),
              (_ctx.has_scenario_error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.scenario_error), 1))
                : _createCommentVNode("", true),
              _cache[16] || (_cache[16] = _createElementVNode("hr", { class: "w-75 text-center" }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[17] || (_cache[17] = _createElementVNode("h4", null, "Job Number", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.job_number) = $event)),
                id: "job_number_input",
                type: "text",
                maxlength: "255"
              }, null, 512), [
                [_vModelText, _ctx.job_number]
              ]),
              (_ctx.has_job_number_error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.job_number_error), 1))
                : _createCommentVNode("", true),
              _cache[18] || (_cache[18] = _createElementVNode("hr", { class: "w-75 text-center" }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[20] || (_cache[20] = _createElementVNode("h4", null, "Platform", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.platform) = $event))
              }, _cache[19] || (_cache[19] = [
                _createElementVNode("option", { value: 0 }, "SP-ED", -1),
                _createElementVNode("option", { value: 1 }, "Simclusive", -1)
              ]), 512), [
                [_vModelSelect, _ctx.platform]
              ]),
              _cache[21] || (_cache[21] = _createElementVNode("hr", { class: "w-75 text-center" }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[28] || (_cache[28] = _createElementVNode("h4", null, "Select user(s)", -1)),
              _createElementVNode("div", _hoisted_16, [
                (_ctx.training_session_users.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.training_session_users, (ts_user) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: ts_user.id
                        }, [
                          _createElementVNode("label", _hoisted_18, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              value: ts_user.user_id,
                              class: "float-start me-2",
                              width: "20",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.training_users) = $event)),
                              onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.has_user_error = false))
                            }, null, 40, _hoisted_19), [
                              [_vModelCheckbox, _ctx.training_users]
                            ]),
                            _cache[25] || (_cache[25] = _createElementVNode("span", { class: "check-icon" }, [
                              _createElementVNode("i", { class: "fas fa-check" })
                            ], -1)),
                            _cache[26] || (_cache[26] = _createElementVNode("span", { class: "checkmark" }, null, -1)),
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("img", {
                                src: !ts_user.user.image ? '/img/no_image.jpg' : ts_user.user.image ,
                                class: "rounded-circle float-end",
                                width: "60"
                              }, null, 8, _hoisted_21),
                              _createElementVNode("span", null, _toDisplayString(ts_user.user.first_name) + " " + _toDisplayString(ts_user.user.last_name), 1),
                              _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
                              _createElementVNode("small", null, _toDisplayString(ts_user.user.email), 1),
                              _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
                              (ts_user.role_id == _ctx.UserRole.SP)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_22, "Standardized Patient"))
                                : _createCommentVNode("", true),
                              (ts_user.role_id == _ctx.UserRole.OBSERVER)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_23, "Observer"))
                                : _createCommentVNode("", true),
                              (ts_user.role_id == _ctx.UserRole.TRAINER)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_24, "Trainer"))
                                : _createCommentVNode("", true),
                              _cache[24] || (_cache[24] = _createElementVNode("hr", { class: "w-75 text-center" }, null, -1))
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_25, _cache[27] || (_cache[27] = [
                      _createElementVNode("p", { class: "p-4" }, "No users available for training sessions.", -1)
                    ])))
              ]),
              (_ctx.has_user_error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.user_error), 1))
                : _createCommentVNode("", true),
              _cache[29] || (_cache[29] = _createElementVNode("hr", { class: "w-75 text-center" }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("button", {
                class: "btn btn-primary btn-md my-2",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.scheduleTrainingSession && _ctx.scheduleTrainingSession(...args)))
              }, "Schedule Training Session")
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createVNode(_component_loading, {
              active: _ctx.schedule_loading || _ctx.loading,
              "is-full-page": false
            }, null, 8, ["active"])
          ]))
    ])
  ]))
}